import { NgModule } from '@angular/core';

import {RolesConnecteComponent} from './components/roles-connecte/roles-connecte.component';
import {CommonModule} from '@angular/common';
import {CommonModuleP8} from '@Common/common-p8.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {MatAngularModule} from '@Common/mat-angular.module';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import {RouterModule} from '@angular/router';
import {PieceJointeUploaderComponent} from './piece-jointe-uploader/piece-jointe-uploader.component';
import {FilePreviewModaleComponent} from './file-preview-modale/file-preview-modale.component';
import { FilePreviewComponent } from './file-preview/file-preview.component';
import {PermissionDeniedComponent} from "app/dar/common/components/permission-denied/permission-denied.component";
import {ListReferenceSelectComponent} from "app/dar/common/list-reference-select/list-reference-select.component";
import {SearchEntiteComponent} from "app/dar/common/search-entite/search-entite.component";
import {SearchEntiteArboComponent} from "app/dar/common/search-entite-arbo/search-entite-arbo.component";
import { ExportExcelComponent } from './export-excel/export-excel.component';
import { ConfigNotifComponent } from './config-notif/config-notif.component';
import { ModelPjViewComponent } from './model-pj/model-pj-view/model-pj-view.component';
import { ModelPjComponent } from './model-pj/model-pj/model-pj.component';
import { ModelPjTypeEditComponent } from './model-pj/model-pj/model-pj-type-edit/model-pj-type-edit.component';
import { ModelPjTypeComponent } from './model-pj/model-pj/model-pj-type/model-pj-type.component';
import { ModelPjFileEditComponent } from './model-pj/model-pj/model-pj-file-edit/model-pj-file-edit.component';
import { ModelPjFileComponent } from './model-pj/model-pj/model-pj-file/model-pj-file.component';
import { ModelPjViewModalComponent } from './model-pj/model-pj-view-modal/model-pj-view-modal.component';
import { StateChipComponent } from './components/state-chip/state-chip.component';

@NgModule({
    imports: [
        CommonModule,
        CommonModuleP8,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        MatAngularModule,
        ReactiveFormsModule,
        MatGridListModule,
        MatInputModule,
        MatFormFieldModule,
        RouterModule,
    ],
    declarations: [
        RolesConnecteComponent,
        PermissionDeniedComponent,
        FilePreviewComponent,
        FilePreviewModaleComponent,
        ListReferenceSelectComponent,
        PieceJointeUploaderComponent,
        SearchEntiteComponent,
        SearchEntiteArboComponent,
        ExportExcelComponent,
        ConfigNotifComponent,
        ModelPjViewComponent,
        ModelPjComponent,
        ModelPjTypeEditComponent,
        ModelPjTypeComponent,
        ModelPjFileEditComponent,
        ModelPjFileComponent,
        ModelPjViewModalComponent,
        StateChipComponent,
    ],
    exports: [
        RolesConnecteComponent,
        PermissionDeniedComponent,
        FilePreviewComponent,
        FilePreviewModaleComponent,
        PieceJointeUploaderComponent,
        ExportExcelComponent,
        ModelPjComponent,
        ModelPjViewComponent,
        StateChipComponent
    ]
})
export class CommonDarModule { }
